import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { InputNumber } from 'primereact/inputnumber'

import i18n from '../../utils/i18n'

export const PriceFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
  suffix?: string,
  placeholder?: string,
) => {
  if (!options) return null

  return (
    <InputNumber
      value={options.value}
      onChange={e => options.filterCallback(e.value, options.index)}
      min={0}
      minFractionDigits={2}
      locale={i18n.language}
      placeholder={placeholder ?? i18n.t('common.placeholders.searchPrice')}
      suffix={suffix}
      showButtons
    />
  )
}
